export { default } from './SEOBox';
